import { REGEX_PASSWORD } from "../../util/util";

export const validacionAlfa = /^[a-zA-Z ]*$/;
export const validacionCorreo = /^[a-zA-Z0-9@_\-. ]*$/;

// Validaciones en inputs de formularios

/*
Validación campo
    - No debe estar vacío
*/
export const validateEmptyField = (field) => {
  const isEmpty = field.trim() === '';
  return isEmpty;
};

/*
Validación de nombre
    - No debe estar vacío
    - No debe admitir caracteres especiales salvo acentos y ñ
    - Minimo 3 caracteres
*/
export const validateName = (name) => {
  if (validateEmptyField(name)) {
    return { error: true, msg: 'Este campo es requerido.' };
  }

  if (name.length < 3) {
    return { error: true, msg: 'Este campo debe tener al menos 3 caracteres.' };
  }
  const pattern = /^[A-Za-záéíóúüñÁÉÍÓÚÜÑ\s]+$/;
  if (!pattern.test(name)) {
    return {
      error: true,
      msg: "No usar caracteres especiales ni números. Esta permitido usar acentos y la letra 'ñ'.",
    };
  }

  return false;
};

/*
Validación de apellido
    - No debe estar vacío
    - No debe admitir caracteres especiales salvo acentos y ñ
    - Minimo 3 caracteres
*/
export const validateLastName = (lastname) => {
  if (validateEmptyField(lastname)) {
    return { error: true, msg: 'Este campo es requerido.' };
  }

  if (lastname.length < 3) {
    return { error: true, msg: 'Este campo debe tener al menos 3 caracteres.' };
  }

  const pattern = /^[A-Za-záéíóúüñÁÉÍÓÚÜÑ\s]+$/;
  if (!pattern.test(lastname)) {
    return {
      error: true,
      msg: "No usar caracteres especiales ni números. Esta permitido usar acentos y la letra 'ñ'.",
    };
  }

  return false;
};

/*
Validación de fecha de nacimiento
    - No debe estar vacío
*/
export const validateDate = (date) => {
  if (validateEmptyField(date)) {
    return { error: true, msg: 'Este campo es requerido.' };
  }
  return false;
};

/*
Validación de ocupación
    - No debe estar vacío
    - No debe admitir caracteres especiales salvo acentos y ñ
    - Minimo 3 caracteres
*/
export const validateOccupation = (occupation) => {
  if(occupation === ''){
    return false
  }
  const pattern = /^[A-Za-záéíóúüñÁÉÍÓÚÜÑ\s]+$/;
  if (!pattern.test(occupation)) {
    return {
      error: true,
      msg: "No usar caracteres especiales ni números. Esta permitido usar acentos y la letra 'ñ'.",
    };
  }

  return false;
};

/*
Validación de número de teléfono
    -No debe estar vacío
    - Exactamente 10 dígitos sin espacios
    -No caracteres especiales
*/
export const validatePhoneNumber = (phoneNumber) => {
  if (validateEmptyField(phoneNumber)) {
    return { error: true, msg: 'Este campo es requerido.' };
  }

  const containsOnlyDigits = /^\d+$/.test(phoneNumber);
  if (!containsOnlyDigits) {
    return { error: true, msg: 'No usar caracteres especiales ni letras.' };
  }

  const isValidSize = /^\d{10}$/.test(phoneNumber);
  if (!isValidSize) {
    return {
      error: true,
      msg: 'Número de teléfono inválido. Debe contener exactamente 10 dígitos sin espacios.',
    };
  }
  return false;
};

/*
Validación de correo electrónico
    - No debe estar vacío
    - Debe contener @
    - Minimo 4 caracteres
*/
export const validateEmail = (email) => {
  if (validateEmptyField(email)) {
    return { error: true, msg: 'Este campo es requerido.' };
  }

  if (email.length < 4) {
    return { error: true, msg: 'Este campo debe tener al menos 4 caracteres.' };
  }

  const isValidArroba = /.+@.+\..+/.test(email);
  if (!isValidArroba) {
    return {
      error: true,
      msg: "Correo electrónico inválido. Debe Incluir '@' y un '.' después del @.",
    };
  }
  return false;
};

/*
Validación de contraseña
    -No debe estar vacío
    - Mínimo 6 caracteres
*/
export const validatePassword = (password) => {
  if (validateEmptyField(password)) {
    return { error: true, msg: 'Este campo es requerido.' };
  }

  const isValidSize = password.length >= 6 && password.length <= 14;
  if (!isValidSize) {
    return { error: true, msg: 'Contraseña mínimo 6 caracteres y máximo 14 caracteres.' };
  }

  if(!REGEX_PASSWORD.test(password)){
    return { error: true, msg: 'La contraseña solo puede contener letras y números, sin caracteres especiales.' };
  }

  return false;
};

/*
Validacion de campo imagen

*/

//Datos bancarios
/*
Validación de número de tarjeta de crédito
    - No debe estar vacio
    - Exactamente 16 dígitos sin espacios
    - No caracteres especiales
*/
export const validateCreditCardNumber = (creditCardNumber) => {
  if (validateEmptyField(creditCardNumber)) {
    return { error: true, msg: 'Este campo es requerido.' };
  }

  const containsOnlyDigits = /^\d+$/.test(creditCardNumber);
  if (!containsOnlyDigits) {
    return { error: true, msg: 'No usar caracteres especiales ni letras.' };
  }

  const isValidSize = /^\d{16}$/.test(creditCardNumber);
  if (!isValidSize) {
    return {
      error: true,
      msg: 'Número de tarjeta inválido. Debe contener exactamente 16 dígitos sin espacios.',
    };
  }

  return false;
};

/*
Validación de CLABE Interbancaria
    - No debe estar vacio
    - Exactamente 18 dígitos sin espacios
    - No caracteres especiales
*/
export const validateClabeInterbancaria = (clabe) => {
  if(!clabe.trim()) {
    return false
  }

  const containsOnlyDigits = /^\d+$/.test(clabe);
  if (!containsOnlyDigits) {
    return { error: true, msg: 'No usar caracteres especiales ni letras.' };
  }

  const isValidSize = /^\d{18}$/.test(clabe);
  if (!isValidSize) {
    return {
      error: true,
      msg: 'CLABE interbancaria inválida. Debe contener exactamente 18 dígitos sin espacios.',
    };
  }
  return false;
};

/*
Validación de nombre de banco
    - No puede estar vacío
    - Debe tener al menos 3 caracteres
    - No se permiten caracteres especiales, excepto espacios
*/
export const validateBankName = (bankname) => {
  if(!bankname.trim()) {
    return false
  }
  if (bankname.length < 3) {
    return { error: true, msg: 'Este campo debe tener al menos 3 caracteres.' };
  }

  const pattern = /^[A-Za-záéíóúüñÁÉÍÓÚÜÑ\s]+$/;
  if (!pattern.test(bankname)) {
    return {
      error: true,
      msg: "No usar caracteres especiales ni números. Esta permitido usar acentos y la letra 'ñ'.",
    };
  }

  return false;
};

/*
Validación de nombre de tarjeta
    - No puede estar vacío
    - Debe tener al menos 3 caracteres
    - No se permiten caracteres especiales, excepto espacios
*/
export const validateCardName = (cardname) => {
  if(!cardname.trim()) {
    return false
  }

  if (cardname.length < 3) {
    return { error: true, msg: 'Este campo debe tener al menos 3 caracteres.' };
  }

  const containsOnlyValidCharacters = /^[a-zA-Z0-9\s]+$/.test(cardname);
  if (!containsOnlyValidCharacters) {
    return {
      error: true,
      msg: 'No se permiten caracteres especiales, excepto espacios.',
    };
  }

  return false;
};

/*
Validaciones input file
    - No debe estar vacio
    - Debe ser del tipo de extension permitida 
*/
export const validateInputFile = (file, allowedExtensions) => {
  if (!file) {
    return { error: true, msg: 'Este campo es requerido.' };
  }

  const fileName = file.name;
  const fileExtension = fileName.split('.').pop().toLowerCase();
  if (!allowedExtensions.includes(fileExtension)) {
    const allowedExtensionsMsg = allowedExtensions.join(', ');
    return {
      error: true,
      msg: `El archivo debe ser un ${allowedExtensionsMsg}.`,
    };
  }

  return false;
};
